import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

function AIUsageHistory() {
  const navigate = useNavigate();
  const [usageData, setUsageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchAIUsage() {
      setLoading(true);
      setError(null);
      try {
        const data = await apiService.getLLMUsage();
        setUsageData(data);
      } catch (err) {
        setError("Failed to load AI usage data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchAIUsage();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatPurpose = (purpose) => {
    return purpose
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const calculateTotalTokens = () => {
    return usageData.reduce((sum, item) => sum + item.total_tokens, 0);
  };

  if (loading) return <div>Loading AI usage data...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <button className="btn btn-secondary" onClick={() => navigate('/ai-usage')}>
        ← Back to AI Usage
      </button>
      
      <div className="course-detail-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: "1rem" }}>
        <div style={{ flex: 1 }}>
          <h1>AI Usage History</h1>
          <p style={{ color: "var(--text-light)" }}>
            Track your AI token consumption
          </p>
        </div>
        <div style={{ 
          padding: "1.5rem", 
          backgroundColor: "white", 
          borderRadius: "12px", 
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          minWidth: "250px",
          textAlign: "center",
          border: "2px solid var(--primary-color)"
        }}>
          <h3 style={{ margin: 0, fontSize: "0.9rem", color: "var(--text-light)", fontWeight: "500" }}>Total Tokens Used</h3>
          <p style={{ 
            fontSize: "2.5rem", 
            fontWeight: "bold", 
            margin: "0.5rem 0 0 0", 
            color: "var(--primary-color)",
            lineHeight: "1"
          }}>
            {calculateTotalTokens().toLocaleString()}
          </p>
        </div>
      </div>

      <div style={{ overflowX: "auto", marginTop: "2rem" }}>
        <table style={{ 
          width: "100%", 
          borderCollapse: "collapse",
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          borderRadius: "8px",
          overflow: "hidden"
        }}>
          <thead>
            <tr style={{ backgroundColor: "var(--primary-color)", color: "white" }}>
              <th style={{ padding: "1rem", textAlign: "left", fontWeight: "600" }}>Purpose</th>
              <th style={{ padding: "1rem", textAlign: "left", fontWeight: "600" }}>Timestamp</th>
              <th style={{ padding: "1rem", textAlign: "right", fontWeight: "600" }}>Tokens Used</th>
            </tr>
          </thead>
          <tbody>
            {usageData.length > 0 ? (
              usageData.map((item, index) => (
                <tr 
                  key={item.id} 
                  style={{ 
                    borderBottom: index < usageData.length - 1 ? "1px solid #e0e0e0" : "none",
                    transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                >
                  <td style={{ padding: "1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      <span style={{ 
                        padding: "0.25rem 0.75rem", 
                        borderRadius: "12px", 
                        fontSize: "0.75rem",
                        backgroundColor: item.purpose === 'question_generation' ? '#e3f2fd' : '#f3e5f5',
                        color: item.purpose === 'question_generation' ? '#1976d2' : '#7b1fa2',
                        fontWeight: "500"
                      }}>
                        {formatPurpose(item.purpose)}
                      </span>
                    </div>
                    {item.object_name && (
                      <div style={{ fontSize: "0.85rem", color: "var(--text-light)", marginTop: "0.25rem" }}>
                        {item.object_name}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: "1rem", color: "var(--text-light)" }}>
                    {formatDate(item.timestamp)}
                  </td>
                  <td style={{ padding: "1rem", textAlign: "right", fontWeight: "600" }}>
                    {item.total_tokens.toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ padding: "2rem", textAlign: "center", color: "var(--text-light)" }}>
                  No AI usage data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AIUsageHistory;
